module.exports = __webpack_public_path__ + "static/media/spend-hero-1-mobile-updated.c7462695.jpg";